import React from 'react';
import { useLanguage } from '../../i18n/useLanguage';

const HELP_URL_EN = 'https://i-think-its-you.at/docs/user/';
const HELP_URL_DE = 'https://i-think-its-you.at/docs/user/de/';

export const Footer: React.FC = () => {
  const { language, t } = useLanguage();
  const helpHref = language === 'de' ? HELP_URL_DE : HELP_URL_EN;

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">
          © {new Date().getFullYear()} ITI. All rights reserved. |{' '}
          <a
            href={helpHref}
            className="footer-link"
            rel="noopener noreferrer"
          >
            {t('footer.help')}
          </a>
          {' '}|{' '}
          <a
            href="https://crime-club.at/crime-club-singles-and-social/i-think-its-you/"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('home.crimeClubOffer')}
          </a>
        </p>
      </div>
    </footer>
  );
};
